export default __webpack_public_path__ + "static/media/blog-2.b7154d99.jpg";